/**
 * Gaya react-select untuk select yang berada DI DALAM sel tabel DataGrid.
 *
 * Dua masalah yang diselesaikan di sini:
 *
 * 1. Daftar pilihannya terpotong tabel. `menuPosition: "fixed"` saja tidak
 *    cukup - DataGrid memasang `transform` pada lapisan penggulungnya, dan
 *    elemen ber-`position: fixed` di dalam ancestor bertransform tetap terikat
 *    pada ancestor itu, jadi tetap ikut terpotong. Yang melepaskannya adalah
 *    `menuPortalTarget={document.body}`; gaya `menuPortal` di bawah memberi
 *    lapisan tumpuk yang cukup tinggi supaya tidak tertutup apa pun.
 *
 * 2. Lebar daftar mengikuti lebar kolom yang sempit, sehingga nama panjang
 *    terpotong. `minWidth` membuat daftarnya melebar sendiri walau kolomnya
 *    sempit.
 *
 * Warnanya mengikuti palet Design System KLH/BPLH: teks ink, garis line, dan
 * sorotan hijau g-50/g-100 - bukan biru bawaan react-select.
 */
const PALET = {
  hijauTua: "#00453F",
  hijau: "#07887D",
  hijauMuda: "#DEF2F1",
  hijauPucat: "#F1F8F8",
  hijauGaris: "#B8EAE6",
  garis: "#E1E8E6",
  tinta: "#283835",
  tintaLembut: "#51625E",
  tintaPudar: "#75847F",
};

export const gayaSelectDalamTabel = {
  menuPortal: (gaya) => ({ ...gaya, zIndex: 1400 }),
  menu: (gaya) => ({
    ...gaya,
    minWidth: 260,
    borderRadius: 8,
    border: `1px solid ${PALET.garis}`,
    boxShadow: "0 8px 24px rgba(16, 32, 29, 0.12)",
    overflow: "hidden",
  }),
  menuList: (gaya) => ({ ...gaya, paddingTop: 4, paddingBottom: 4 }),
  control: (gaya, keadaan) => ({
    ...gaya,
    minHeight: 34,
    borderColor: keadaan.isFocused ? PALET.hijau : PALET.garis,
    boxShadow: "none",
    ":hover": { borderColor: PALET.hijauGaris },
  }),
  valueContainer: (gaya) => ({ ...gaya, paddingTop: 0, paddingBottom: 0 }),
  singleValue: (gaya) => ({ ...gaya, color: PALET.tinta, fontSize: "10pt" }),
  placeholder: (gaya) => ({ ...gaya, color: PALET.tintaPudar, fontSize: "10pt" }),
  input: (gaya) => ({ ...gaya, color: PALET.tinta, fontSize: "10pt" }),
  option: (gaya, keadaan) => ({
    ...gaya,
    fontSize: "10pt",
    color: keadaan.isSelected ? PALET.hijauTua : PALET.tintaLembut,
    backgroundColor: keadaan.isSelected
      ? PALET.hijauMuda
      : keadaan.isFocused
        ? PALET.hijauPucat
        : "transparent",
    ":active": { backgroundColor: PALET.hijauMuda },
  }),
  indicatorSeparator: (gaya) => ({ ...gaya, backgroundColor: PALET.garis }),
};

/** Sasaran portal; aman dipanggil saat dirender di sisi peladen. */
export function sasaranPortalMenu() {
  return typeof document !== "undefined" ? document.body : null;
}
